<ng-template #body>
    <div
        *ngFor="let item of items; index as i"
        [style.background]="item?.persona?.color"
        (click)="onSelected(item, i)"
        class="flow"
        [class.selected]="item.selected"
    >
        <span class="flow__step">{{i + 1}}</span>
        <span [class]="'flow__location ' + (item.persona?.id | personaIcon)"></span>
        <span [class]="'flow__status ' + ((item.status) ? 'complete' : 'incomplete')" *ngIf="item.isOwner || (item.isTruckCarrierDelivery && isAllJourneyValidated)"></span>
    </div>
</ng-template>
<ng-template #itemSelected>
    <div
        *ngIf="configObj?.itemSelected?.selected"
        [style.background]="configObj?.itemSelected?.persona?.color"
        class="flow current selected"
    >
        <span class="flow__step">{{configObj?.itemSelected?.index}}</span>
        <span [class]="'flow__location ' + (configObj?.itemSelected?.persona?.id | personaIcon)"></span>
        <span [class]="'flow__status ' + (configObj?.itemSelected?.status ? 'complete': 'incomplete')" *ngIf="configObj?.itemSelected?.isOwner || (configObj?.itemSelected?.isTruckCarrierDelivery && isAllJourneyValidated)"></span>
    </div>
</ng-template>
<app-panel-box
    [bodyTemplate]="body"
    [config]="configObj"
    [itemSelectedTemplate]="itemSelected"
></app-panel-box>
